import { CautionSpot, CheckCircleSpot, CircleCvna } from '@carvana/ds-icons';
import { icon } from '@carvana/ds-styles';
import { ShieldCheck } from 'lucide-react';
import React from 'react';
import GapCoverageCar from '|/icons/gap-coverage-car.png';
import styles from '../../gap-coverage.module.css';

const ExampleVisualization: React.FC = () => {
  return (
    <div className={styles.example}>
      <h2 className={styles.exampleHeader}>Example</h2>
      <div className={styles.visualization}>
        <div className={styles.amountOwedContainer}>
          <span className={styles.amountOwedValue}>$15,000</span>
          <span className={styles.amountOwedText}>Owed on your vehicle</span>
        </div>
        <div className={styles.vehicleImageAndExplainerContainer}>
          <div className={styles.vehicleImageContainer}>
            <div className={styles.explainerLine} />
            <img
              src={GapCoverageCar}
              alt="Gap coverage vehicle illustration"
              className={styles.vehicleImage}
            />
            <div className={styles.checkIcon}>
              <CircleCvna color={icon.inverse} size={33} />
              <CheckCircleSpot size={24} color={icon.primaryActive} />
            </div>
            <div className={styles.cautionIcon}>
              <CircleCvna color={icon.strong} size={33} />
              <CautionSpot size={24} color={icon.inverse} />
            </div>
            <div className={styles.explainer}>
              <ShieldCheck size={24} />
              GAP coverage protects you from the amount still owed.
            </div>
          </div>
        </div>
      </div>
      <div className={styles.exampleAmounts}>
        <div className={styles.exampleAmountBox}>
          <span className={styles.exampleAmountBoxLabel}>Insurance payout</span>
          <span className={styles.exampleAmountBoxValue}>$12,000</span>
        </div>
        <div className={styles.exampleAmountBox}>
          <span className={styles.exampleAmountBoxLabel}>Still owed (GAP)</span>
          <span className={styles.exampleAmountBoxValue}>$3,000</span>
        </div>
      </div>
    </div>
  );
};

export default ExampleVisualization;
